import React from 'react';
import PropTypes from 'prop-types';

function SuccessCheckRingIcon({ className = '', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 80 80' fill='none' className={className} {...props}>
      <circle cx='40' cy='40' r='36' stroke='currentColor' strokeWidth='4' fill='none' />
      <path d='M24 40 L35 52 L56 28' stroke='currentColor' strokeWidth='4.5' strokeLinecap='round' strokeLinejoin='round' fill='none' />
    </svg>
  );
}

SuccessCheckRingIcon.propTypes = {
  className: PropTypes.string,
};

export default SuccessCheckRingIcon;
